import Vue from "vue";
import Router from "vue-router";
import Box from "../components/Box.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Box,
    },
  ],
});
